export default function persistCart (store) {
  const STORAGE_KEY = 'app_cart'

  // TTL de 30 min - evitar que o carrinho fique desatualizado
  const TTL = 30 * 60 * 1000

  // escuta mutações e persiste se forem mutações na store cart
  store.subscribe((mutation, state) => {
    const cartMutations = [
      'addToCart',
      'clearCart',
      'resetCart',
      'deleteProduct',
      'increaseQtty',
      'decreaseQtty',
      'overrideCart',
      'editProduct'
    ]

    const isCartMutation = cartMutations.includes(mutation.type.replace('cart/', ''))
    if (isCartMutation) {
      const cartWithTimestamp = {
        cart: state.cart.cart,
        timestamp: new Date().toISOString()
      }
      localStorage.setItem(STORAGE_KEY, JSON.stringify(cartWithTimestamp))
    }
  })

  // carrega o carrinho salvo no localStorage e aplica na store cart
  const savedCart = localStorage.getItem(STORAGE_KEY)
  if (savedCart) {
    try {
      const parsed = JSON.parse(savedCart)
      const expired = Date.now() - new Date(parsed.timestamp).getTime() > TTL
      if (expired) {
        localStorage.removeItem(STORAGE_KEY)
      } else {
        if (!Array.isArray(parsed.cart)) {
          store.commit('resetCart')
        } else {
          store.commit('overrideCart', parsed.cart)
        }
      }
    } catch (err) {
      console.warn('Erro ao restaurar carrinho do localStorage:', err)
    }
  }
}
